<template>
  <div class="synchronous">
    <div class="synchronous-header">
      <div>
        <el-button type="primary" @click="handelCouponBtn(null, 'add')">新增券</el-button>
        <el-button type="primary" @click="handelCinemaNum">同步活动影院数量</el-button>
        <FilterCinemaLinshi
          v-model="cinemaVisible"
          :types="1"
          :ids="[]"
          :template-code-set="templateCodeSet"
          @close="cinemaVisible = false"
          @getList="onFormReset"
        ></FilterCinemaLinshi>
        <!--        <span class="synchronous-header-tip">点击该按钮后，手动同步对应快手ID的商品到我们自己数据库，主要同步列表信息和商品适用门店。</span>-->
      </div>
      <div class="forms-container">
        <el-form :model="searchForm" class="search-form" ref="searchFormRef">
          <el-form-item label="券编码" prop="code">
            <el-input style="width:200px" :maxlength="255" v-model="searchForm.templateCode" placeholder="请输入券编码" />
          </el-form-item>
          <el-form-item label="券名称" prop="name">
            <el-input style="width:170px" :maxlength="255" v-model="searchForm.name" placeholder="请输入券名称" />
          </el-form-item>
          <el-form-item label="商品ID" prop="name">
            <el-input style="width:170px" :maxlength="255" v-model="searchForm.thirdProductId" placeholder="请输入商品ID" />
          </el-form-item>
          <el-form-item>
            <!-- 操作按钮 -->
            <el-button type="warning" @click="onFormSearch">查询</el-button>
            <el-button type="warning" plain @click="onFormReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <my-table :tableData="table.tableData" :headerList="table.headerList" :loading="table.loading"
      :page-size="params.pageSize" :currentPage="params.pageNo" :total="table.total"
      :selectionType="true" @selection-change="handleSelectionChange"
      @currentPage-change="handlePageChange" @sizePage-change="handleSizeChange">
      <!-- 自定义内容 -->
      <template v-slot:startTime="{ data }">
        <div v-if="data.useDateType === 1">
          <div>开始：{{ data.startTime }}</div>
          <div>结束：{{ data.endTime }}</div>
        </div>
        <div v-else>
          购买后{{ data.expireDate }}天内有效
        </div>

      </template>
      <!-- 自定义内容 -->
      <template v-slot:cinemaNum="{ data }">
        <div v-if="data.movieTemplateLimitJson.cinemaFilterType === 0">全部影院</div>
        <div v-else>{{ data.cinemaNum }}</div>
      </template>
      <template v-slot:stock="{ data }">
        <div>{{ data.stock }}/{{ data.totalStock }}</div>
      </template>
      <template v-slot:operation="{ data }">
        <div class="btn-box">
          <el-button type="text" @click="handelCouponBtn(data, 'view')">查看</el-button>
          <el-button type="text" @click="handelCouponBtn(data, 'edit')">编辑</el-button>
          <el-button type="text" v-if="data.status === 0" @click="handelShelf(data, 1)">上架</el-button>
          <el-button type="text" v-else @click="handelShelf(data, 0)">下架</el-button>
        </div>
      </template>
      <template v-slot:status="{ data }">
        <el-tag v-if="data.status === 0" type="danger" size="small">已下架</el-tag>
        <el-tag v-if="data.status === 1" type="success" size="small">已上架</el-tag>
      </template>
    </my-table>
    <createCoupon ref="createCouponRef" @updateDy="updateDy"> </createCoupon>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import myTable from '@/components/my-table.vue'
import debounce from "@/utils/debounce.js";
import createCoupon from "./component/createCoupon.vue";
import FilterCinemaLinshi from './component/FilterCinemaLinshi.vue'

export default {
  components: {
    createCoupon,
    myTable,
    FilterCinemaLinshi,
  },
  data() {
    return {
      cinemaVisible: false,
      multipleSelection: [],
      searchForm: {
        templateCode: '',
        name: '',
        thirdProductId: '',
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      table: {
        loading: false,
        total: 0,
        tableData: [],
        headerList: [
          {
            prop: 'createTime',
            label: '创建时间',
            width: '180',
            // customRender:'customName'
          },
          {
            prop: 'templateCode',
            label: '商品券编码',
            width: '200',
          },
          {
            prop: 'status',
            label: '券状态',
            width: '100',
            customRender: 'status',
          },
          {
            prop: 'name',
            label: '券名称',
            width: '200'
          },
          {
            prop: 'thirdProductId',
            label: '商品ID',
            width: '200'
          },
          {
            prop: 'couponPriceBd',
            label: '面值（元）',
            width: '100'
          },
          {
            prop: 'sellPriceBd',
            label: '售价（元）',
            width: '100'
          },
          {
            prop: 'startTime',
            label: '有效时间',
            customRender: 'startTime',
            width: '230',
          },
          {
            prop: 'stock',
            label: '库存',
            width: '120',
            customRender: 'stock',
          },
          {
            prop: 'cinemaNum',
            label: '适用影院数量',
            width: '120',
            customRender: 'cinemaNum',
          },
          {
            prop: 'useTypeStr',
            label: '适用座位',
          },
          {
            prop: 'operation',
            label: '操作',
            width: '120',
            customRender: 'operation',
            fixed: 'right', //是否固定列
          }
        ]
      },
      productStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已上架",
          value: 1,
        },
        {
          label: "已下架",
          value: 2,
        },
        {
          label: "已售罄",
          value: 3,
        },
        {
          label: "已删除",
          value: 5,
        },
      ],
    }
  },
  computed: {
    templateCodeSet() {
      return this.multipleSelection.map((item) => item.templateCode)
    },
  },
  created() {
    this.getTbLifeCouponQueryList()
  },
  methods: {
    handelCinemaNum() {
      if(this.multipleSelection.length === 0) {
        this.$message.error('请先勾选优惠券')
        return
      }
      this.cinemaVisible = true
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    updateDy() {
      this.params.pageNo = 1
      this.params.pageSize = 10
      this.getTbLifeCouponQueryList();
    },
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getTbLifeCouponQueryList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(() => {
        this.searchForm = {
          templateCode: '',
          productStatus: '',
          name: '',
          thirdProductId: '',
        }
        this.multipleSelection = []
        this.$refs['searchFormRef'].resetFields();
        this.getTbLifeCouponQueryList()
      }, 1000, true)
    },
    handelFlushed() {
      debounce(() => {
        this.getTbLifeCouponQueryList()
      }, 1500, true)
    },
    reset() {
      this.params = {
        pageNo: 1,
        pageSize: 10,
      }
      this.getTbLifeCouponQueryList()
    },
    // 淘宝天猫券列表查询
    async getTbLifeCouponQueryList() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      this.table.loading = true;
      const res = await MiniModel.couponActivityPage({
        ...this.params,
        appKey: appKeyMini,
        ...this.searchForm,
        // couponPlatformType:80,
        activityType: 80
      }).finally(() => {
        this.table.loading = false;
      })
      console.log(res, 'res==淘宝天猫券列表查询')
      if (res.data.code === 200) {
        this.table.tableData = res.data.data.list.map(item => {
          return {
            ...item,
          }
        })
        this.table.total = res.data.data.total;
        this.params.pageNo = res.data.data.pageNo
        console.log(this.table.tableData, 'this.table.tableData')
      } else {
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },

    async handelShelf(item, status) {
       const res = await MiniModel.shelfCoupon({
        templateCode: item.templateCode,
        status
      })

      if(res.data.code === 200) {
        this.$message.success('操作成功')
        this.getTbLifeCouponQueryList()
      } else {
        this.$message.error(res.data.message)
      }
    },

    handelCouponBtn(row, type) {
      this.$refs.createCouponRef.open(row, type)
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getTbLifeCouponQueryList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getTbLifeCouponQueryList()
    },
  }
}
</script>

<style scoped lang="less">
.synchronous {
  &-header {

    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    &-tip {
      color: #666;
      margin-left: 10px;
      font-size: 12px;
    }

    &__icons {
      i {
        font-size: 22px;
        cursor: pointer;
        margin-right: 50px;
        color: #409eff;
      }
    }
  }
}

.forms-container {
  margin-top: 10px;
}
</style>
<style>
.btn-box {
  .el-button+.el-button {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDyPoiNew/DyPoiCouponSynchronous.vue